<template>
    <div>
        <el-select v-model="selectedPart" class="select" clearable filterable remote :remote-method="searchParts" :placeholder="$t('common.pleaseSelectPart')" :loading="loading" @change="partSelected">
            <el-option v-for="item in parts" :key="item.id" :label="item.name" :value="item.id"></el-option>
        </el-select>
    </div>
</template>

<script>
import api from "../api";
export default {
  name: "claim-part-selector",

  props: {
    value: {
      required: false
    },
    selectedPartData: {
      type: Object,
      default: null
    },
    serviceCompanyId: {
      type: Number
    },
    productId: {
      type: Number
    }
  },
  data() {
    return {
      loading: false,
      selectedPart: this.value,
      parts: [],
    };
  },
  watch: {
    value(newValue) {
      this.selectedPart = newValue;
    },
    selectedPartData: {
      immediate: true,
      deep: true,
      handler(part) {
        if (part && !this.parts.find(item => item.id === part.id)) {
          this.parts = [part].concat(this.parts);
        }
      }
    }
  },
  methods: {
    searchParts(term) {
      if (term !== "") {
        var self = this;
        self.loading = true;
        api
          .getParts(term, this.serviceCompanyId, this.productId)
          .then(function(response) {
            self.loading = false;
            self.parts = response.data;
          });
      }
    },
    partSelected(value) {
      if (value === "" || value === undefined || value === null) {
        this.parts = [];
        this.selectedPart = undefined;
        this.$emit("input", undefined);
        this.$emit("part-selected", undefined);
        return;
      }
      this.$emit("input", value);
      this.$emit("part-selected", this.parts.find(c => c.id === value));
    },
    reset() {
      this.selectedPart = undefined;
      this.parts = [];
    }
  }
};
</script>

<style scoped>
.select {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// ClientApp/app/claims/components/ClaimPartSelector.vue